module.exports = __webpack_public_path__ + "img/game_main_pc_splus_off.c6496f41.png";